import React from 'react'
import { useAxios } from '../hooks/useAxios'
import { useSearchParams } from 'react-router-dom'
import Spinner from '../components/Spinner'
import Card from '../components/Card'
import Btn from '../components/Btn'
import { verifyEmail } from '../api/verifyEmail'
import { ReactSVG } from 'react-svg'

function EmailVerificationPage(): React.ReactElement {
  const { loading, error, fire } = useAxios()
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')

  React.useEffect(() => {
    void fire(verifyEmail(String(token)))
  }, [])

  if (loading) {
    return <Spinner></Spinner>
  } else {
    return (
      <div className="auth-layout-view" style={{ maxWidth: '44rem' }}>
        <Card className="auth-layout-view__card auth-card">
          <div className="auth-card__head">
            <h1>
              Регистрация на{' '}
              <ReactSVG
                wrapper="span"
                className="auth-logo"
                src="/i/logo-sm.svg"
              />
            </h1>
          </div>
          {error ? (
            <div className="auth-card__content">
              <p>{error.message}</p>
            </div>
          ) : (
            <div className="auth-card__content">
              <p>
                Email успешно подтвержден, вы можете войти в систему, используя
                свою учетную запись
              </p>

              <div className="u-flex u-flexJustifyCenter mt-md-8 mt-sm-6">
                <Btn to={'/auth'}>Войти</Btn>
              </div>
            </div>
          )}
        </Card>
      </div>
    )
  }
}

export default EmailVerificationPage
